import { render, staticRenderFns } from "./TransferredVehicles.vue?vue&type=template&id=48b6c338"
import script from "./TransferredVehicles.vue?vue&type=script&lang=js"
export * from "./TransferredVehicles.vue?vue&type=script&lang=js"
import style0 from "./TransferredVehicles.vue?vue&type=style&index=0&id=48b6c338&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports